import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import '../styles/portal/layout/layout.css'

interface LayoutProps {
  children: React.ReactNode
  allowScrolling?: boolean // For report pages that need natural scrolling
}

const Layout: React.FC<LayoutProps> = ({ children, allowScrolling = false }) => {
  const { isAuthenticated, logout } = useAuth0()

  const handleSignOut = async () => {
    await logout({ logoutParams: { returnTo: window.location.origin + '/login' } })
  }

  return (
    <div className="absolute inset-0 flex h-screen w-screen flex-col bg-gray-50">
      {isAuthenticated && (
        <header className="header">
          <div className="flex items-center justify-between px-6 py-4">
            <div className="flex items-center gap-4">
              <img src="/icons/Inflection_Icon_Light 1.svg" alt="Inflection Logo" className="icon" />
              <span className="text-xl text-white">Inflection Medicine</span>
            </div>
            <button
              onClick={handleSignOut}
              className="flex items-center gap-2 text-white transition-colors duration-200 hover:text-gray-200"
              title="Sign Out"
            >
              <img src="/icons/signout.svg" alt="Sign Out" />
            </button>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main className={`w-full flex-1 ${allowScrolling ? 'overflow-auto' : 'overflow-hidden'}`}>{children}</main>
    </div>
  )
}

export default Layout
